module.exports = __webpack_public_path__ + "static/media/user-2.3690cc0d.png";